import { Grid, Typography } from '@mui/material';
import ActionButton from 'components/buttons';
import { styles } from './styles';

interface IAddVariants {
  onAdd: () => void;
  isDisabled?: boolean;
}

export const AddVariants = ({ isDisabled, onAdd }: IAddVariants) => {
  return (
    <Grid>
      <Typography sx={styles.heading}>Variants</Typography>
      <Grid sx={styles.container}>
        <Typography sx={styles.label}>
          Require a choice when this item is confirmed. Add one or more variant types (e.g., Color,
          Size). Then define the choices.
        </Typography>
        <ActionButton
          type="button"
          disabled={isDisabled}
          onClick={onAdd}
          label="+"
          variant="secondary"
        />
      </Grid>
    </Grid>
  );
};
